export const searchParamsToObject = (params: URLSearchParams) =>
  [...params.keys()].reduce<Record<string, unknown>>(
    (agg, key) => ({
      ...agg,
      [key]: params.get(key),
    }),
    {},
  );
